import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslate } from 'react-admin'

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: '10px',
  },
  title: {
    fontSize: '26px',
    lineHeight: '30px',
    ...theme.mundi.font.lato700Normal,
  },
}))

const PanelHeader = ({ title }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>{title}</Typography>
    </div>
  )
}

export default PanelHeader
